import { useQuery } from '@tanstack/react-query';
import { authService } from '../../../../services/authService';
import { getMyEpcRoles } from '../../../../services/epcProjectService';

/**
 * Returns the EPC project-membership roles the caller holds (across any project).
 * Safe to call when the user is not in EPC context — fails closed to `[]`, no retries.
 *
 * Pass `enabled: false` from non-EPC contexts to skip the request entirely
 * (the sidebar uses this to avoid an extra round-trip outside EPC).
 */
export function useMyEpcRoles(options: { enabled?: boolean } = {}) {
  const userId = String(authService.getUser()?._id ?? '');
  return useQuery({
    // Keyed by user id: the cache outlives an SPA logout, so an unscoped key
    // served the previous user's roles to the next login.
    queryKey: ['epc', 'me', 'roles', userId],
    queryFn: getMyEpcRoles,
    staleTime: 5 * 60_000,
    retry: false,
    refetchOnWindowFocus: false,
    enabled: options.enabled !== false,
  });
}
